import { AfterViewInit, Component, Inject, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {roundOfMaxsize} from '../common/common'
import { REGISTRY_APPLICATION } from "../../../../../global/tokens";

@Component({
  selector: 'app-family-history-chart',
  templateUrl: './family-history-chart.component.html',
  styleUrls: ['./family-history-chart.component.scss']
})
export class FamilyHistoryChartComponent implements AfterViewInit, OnDestroy{
  @Input() dataInsight: any;

  constructor(
    @Inject(REGISTRY_APPLICATION) public application: string,
  ) {
  }

  ngAfterViewInit() {
    const isDesktop = window.matchMedia('(pointer: fine)').matches;
  
    if (isDesktop) {
      window.addEventListener('resize', this.handleResize);
    }
  }
  
  ngOnDestroy(): void {
    window.removeEventListener('resize', this.handleResize);
  }
  
  handleResize = () => {
    const isDesktop = window.matchMedia('(pointer: fine)').matches;
    if (isDesktop) {
      window.location.reload();
    }
  };
  

  ngOnChanges(changes: SimpleChanges) {
    if(this.application === 'Admin'){
      if (changes['dataInsight'] && changes['dataInsight'].firstChange) {
        this.createDoughnutChart()
        this.createBarChart()
        }
    }else{
      if (changes['dataInsight'] && !changes['dataInsight'].firstChange) {
        this.createDoughnutChart()
        this.createBarChart()
        }
    }
   
  }

  createDoughnutChart() {
    // the condition is reversed, the pie chart will display data in the opposite order or direction.
    const data = [...this.dataInsight?.family_data?.family_percentage].reverse();
    const labels = data
    const values = data
   
    // Index value to match the highlihtedBox
    const indexValue = this.dataInsight?.index;

    const canvas: any = document.getElementById('familyHistoryDoughnutChart');
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth + 100;
    canvas.height = 300;
  
    const chart = new Chart(ctx, {
      type: 'doughnut', 
      plugins: [ChartDataLabels], 
      options: {
          tooltips: {
          backgroundColor: "white",
          titleFontColor: "#000",
          bodyFontColor: "#000",
          borderColor: "#ccc",
          borderWidth: 1, 
          titleFontSize:window.innerWidth < 768 ? 12 : 18,
          bodyFontSize:window.innerWidth < 768 ? 12 : 16,
          callbacks: {
            label: function(tooltipItem, data) {
              const totalNumber =[...this.dataInsight?.family_data?.family_count].reverse();
              const total =totalNumber[tooltipItem.index];
              return `${total} (${data.datasets[0].data[tooltipItem.index].toString()}%)`;
          }.bind(this)
          }
        },
        responsive: true,
        plugins: {
          datalabels: {
            color: (context) => {
              const index = context.dataIndex;
              const swappedIndex = index === 0 ? 1 : index === 1 ? 0 : index;
              return swappedIndex === indexValue ? "rgba(81,103,163,1)" : "#fff";
          },
          backgroundColor: (context) => {
            const index = context.dataIndex;
            const swappedIndex = index === 0 ? 1 : index === 1 ? 0 : index;
              return swappedIndex === indexValue ? "#fff" : null;
          },
          borderWidth: (context) => {
            const index = context.dataIndex;
            const swappedIndex = index === 0 ? 1 : index === 1 ? 0 : index;
            return swappedIndex === indexValue ? 2 : 0;
        },
        padding:(context) =>{
          const index = context.dataIndex;
          const swappedIndex = index === 0 ? 1 : index === 1 ? 0 : index;
         return swappedIndex === indexValue ? {top:6,bottom:4,left:6,right:6} : 0;
       },
          borderRadius: 5,
            font: {
              size:window.innerWidth < 768 ? 14 : 17,   
              weight:500
            },
            formatter: (value: number) => {
              return `${value}%`; 
            },
          },
        },
        legend: {
          display: false,
        },
      
      },
      data: {
        labels: labels,
        datasets: [{
          borderWidth: 0,
          data: values,
          backgroundColor: [
            'rgba(81,103,163, 1)',
            'rgba(82,202,224,1)', 
          ],
        }],
      },
    });
  }


  createBarChart() {
    const labels = ['Biological Mother', 'Biological Father', 'Biological Sibling'];
    const values = this.dataInsight?.family_member_data.family_member_count; 

    const mobileLabels = ['Mother', 'Father', 'Sibling'];
    // --------------Calculate Max size----------------------------
    let {roundedMaxSize,stepSize}=roundOfMaxsize(this.dataInsight?.family_member_data?.total_count)
    const percentageValue = this.dataInsight?.family_member_data?.data || [];
    // ---------------------------------------------------------------------
    const canvas: any = document.getElementById('familyHistoryBarChart');
    const ctx = canvas.getContext('2d');
    canvas.width = canvas.offsetWidth;
    canvas.height = 280;
    Chart.defaults.global.defaultFontFamily= 'Poppins, sans-serif'
    const chart = new Chart(ctx, {
      type: 'bar',
      plugins: [ChartDataLabels],
      options: {
        tooltips: {
          backgroundColor: "white",
          titleFontColor: "#000",
          bodyFontColor: "#000",
          borderColor: "#ccc",
          borderWidth: 1,
          titleFontSize:window.innerWidth < 768 ? 12 : 16,
          bodyFontSize:window.innerWidth < 768 ? 12 : 15,
          callbacks: {
            label: function(tooltipItem, data) {
              const index = tooltipItem.index;
              const value = data.datasets[0].data[index] as number;
              const percentage = percentageValue[index] !== undefined ? `${percentageValue[index]}%` : "";
              return `${value} (${percentage})`;
            }
          }
        },
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          datalabels: {
            color: '#fff', 
            font: {
              size: window.innerWidth <= 820 ? 12 : 17,
              weight:500    
            },
            formatter: (value, context) => {
              const index = context.dataIndex;
              const displayValue = percentageValue[index] !== undefined ? `${percentageValue[index]}%` : '';
              return displayValue;
            }
          },
        },
        legend: {
          display: false, 
        },
       
        scales: {
          xAxes: [{
            ticks: {
              fontSize:window.innerWidth < 768 ? 12 : 16,
            },
            gridLines: {
              display: true,
              color: 'rgba(200, 200, 200, 0.5)', 
            },
            scaleLabel: {
              display: true,
              labelString: 'Family Member',
              fontSize:window.innerWidth < 768 ? 14 : 16,
              fontColor: "rgba(62,62,62,1)",
              fontStyle:"500",
              fontFamily:"Montserrat,sans-serif"
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              max: roundedMaxSize, 
              stepSize: stepSize,
              fontSize:window.innerWidth < 768 ? 12 : 16,
            },
            gridLines: {
              display: true,
              color: 'rgba(200, 200, 200, 0.5)', 
            },
            scaleLabel: {
              display: true,
              labelString:window.innerWidth <= 1024 ? 'Participants': 'Number of participants',
              fontSize:window.innerWidth <= 1024 ? 14 : 16,
              fontColor: "rgba(62,62,62,1)",
              fontStyle:"500",
              fontFamily:"Montserrat,sans-serif"
            },
          }],
        },
      },
      data: {
        labels:window.innerWidth <= 1024 ? mobileLabels : labels,
        datasets: [{
          data: values,
          backgroundColor: "rgba(81, 103, 163, 1)",
          borderWidth: 1, 
        }],
      },
    });
  }


}
